<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：メッセージ送信ダイアログ
 *
 * 作成者：2021/12/2 ノア）黄
 * 最終修正者：2022/2/5 ノア）黄
 *
 -->
<template>
  <div>
    <ttiDialog
      :isShow="isDetailShow"
      @handelDisplay="onHandelDetailDisplay"
      :manualKey="manualKey"
      :title="$t('notifications.messageSend')"
      width="650px"
      class="tti-message-send-dialog"
    >
      <template slot="body">
        <div>
          <div class="table-container">
            <el-table header-row-class-name="tti-master-table-header" :data="transmissionHistoryDetailData" border>
              <el-table-column prop="userName" :label="$t('notifications.userName')" width="160"> </el-table-column>
              <el-table-column prop="userId" :label="$t('notifications.userCode')" width="150"> </el-table-column>
              <el-table-column :label="$t('notifications.recieveUserReadStatus')" width="160">
                <template slot-scope="scope">
                  {{ getRecieveUserReadStatuslabel(scope.row.status) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('notifications.operation')" width="150">
                <template slot-scope="scope">
                  <el-button
                    class="tti-btn-default tti-btn-001"
                    v-tooltip="getTooltip(tooltipType.reSend)"
                    @click="onResendButtonClick(scope.row)"
                  >
                    {{ $t('notifications.reSend') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </template>
    </ttiDialog>
    <!-- メッセージ送信ダイアログ -->
    <ttiDialog
      v-if="isShow"
      :isShow="isShow"
      @handelDisplay="onHandelDisplay"
      :manualKey="manualKey"
      :title="dialogTitle"
      width="800px"
      class="tti-message-send-dialog"
    >
      <template slot="body">
        <div v-show="dialogContentType === ContentType.MESSAGE_SEND">
          <el-steps :active="currentStep" simple>
            <!-- メッセージ内容 -->
            <el-step :title="$t('notifications.messageContent')"> </el-step>
            <!-- ユーザ選択 -->
            <el-step :title="$t('notifications.userChoose')"></el-step>
            <!-- 確認頁 -->
            <el-step :title="$t('notifications.confirmPage')"></el-step>
          </el-steps>

          <!-- メッセージ内容 -->
          <div v-if="currentStep === 0 || currentStep === 2">
            <el-form
              ref="messageSendFormRef"
              :model="messageSendForm"
              :rules="messageSendRules"
              :disabled="currentStep === 2"
              label-width="100px"
              label-position="left"
              class="tti-message-send-form"
              size="mini"
            >
              <!-- 送信タイプ -->
              <el-form-item prop="sendType" :label="$t('notifications.sendType')">
                <el-radio-group v-model="messageSendForm.sendType">
                  <el-radio v-for="item in messageSendTypeOptions" :key="item.code" :label="item.code">
                    {{ item.name }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 送信時刻 -->
              <el-form-item prop="sendDate" :label="$t('notifications.sendTime')">
                <el-date-picker
                  v-model="messageSendForm.sendDate"
                  type="datetime"
                  format="yyyy/MM/dd HH:mm"
                  value-format="yyyy/MM/dd HH:mm"
                  size="small"
                  :editable="false"
                  :clearable="false"
                  :disabled="isSendTimeDisabled"
                ></el-date-picker>
              </el-form-item>
              <!-- 題名 -->
              <el-form-item prop="title" :label="$t('notifications.title')">
                <el-input v-model.trim="messageSendForm.title" size="small"> </el-input>
                <span v-if="currentStep === 0" class="input-append">
                  <span>{{ $t('notifications.surplus') }}</span>
                  <span>{{ getSurplusChars(messageSendForm.title) }}</span>
                  <span>{{ $t('notifications.char') }}</span>
                </span>
              </el-form-item>
              <!-- 本文１ -->
              <el-form-item prop="context1" :label="$t('notifications.context1')">
                <el-input v-model.trim="messageSendForm.context1" size="small"> </el-input>
                <span v-if="currentStep === 0" class="input-append">
                  <span>{{ $t('notifications.surplus') }}</span>
                  <span>{{ getSurplusChars(messageSendForm.context1) }}</span>
                  <span>{{ $t('notifications.char') }}</span>
                </span>
              </el-form-item>
              <!-- 本文２ -->
              <el-form-item prop="context2" :label="$t('notifications.context2')">
                <el-input v-model.trim="messageSendForm.context2" size="small"> </el-input>
                <span v-if="currentStep === 0" class="input-append">
                  <span>{{ $t('notifications.surplus') }}</span>
                  <span>{{ getSurplusChars(messageSendForm.context2) }}</span>
                  <span>{{ $t('notifications.char') }}</span>
                </span>
              </el-form-item>
              <!-- 本文３ -->
              <el-form-item prop="context3" :label="$t('notifications.context3')">
                <el-input v-model.trim="messageSendForm.context3" size="small"> </el-input>
                <span v-if="currentStep === 0" class="input-append">
                  <span>{{ $t('notifications.surplus') }}</span>
                  <span>{{ getSurplusChars(messageSendForm.context3) }}</span>
                  <span>{{ $t('notifications.char') }}</span>
                </span>
              </el-form-item>
              <!-- 本文４ -->
              <el-form-item prop="context4" :label="$t('notifications.context4')">
                <el-input v-model.trim="messageSendForm.context4" size="small"> </el-input>
                <span v-if="currentStep === 0" class="input-append">
                  <span>{{ $t('notifications.surplus') }}</span>
                  <span>{{ getSurplusChars(messageSendForm.context4) }}</span>
                  <span>{{ $t('notifications.char') }}</span>
                </span>
              </el-form-item>
            </el-form>
            <!-- 選択済みユーザ -->
            <div class="selected-user-area" v-if="currentStep === 2">
              <label>{{ $t('notifications.selectedUser') }}</label>
              <label>{{ selectedUser.length }}</label>
              <label>{{ $t('notifications.selectedUserUnit') }}</label>
              <div class="table-container">
                <el-table
                  header-row-class-name="tti-master-table-header"
                  :data="selectedUser"
                  row-key="userId"
                  :empty-text="$t('messages.common.emptyTableData')"
                  border
                >
                  <el-table-column prop="userName" :label="$t('notifications.userName')" width="180"> </el-table-column>
                  <el-table-column prop="userId" :label="$t('notifications.userCode')" width="180"> </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- ユーザ選択 -->
          <div v-show="currentStep === 1">
            <div class="table-container">
              <el-table
                ref="userSelectTable"
                header-row-class-name="tti-master-table-header"
                :data="userTableData"
                row-key="userId"
                border
                default-expand-all
                :empty-text="$t('messages.common.emptyTableData')"
                :tree-props="{ children: 'userList', hasChildren: 'hasChildren' }"
                @selection-change="handleSelectionChange"
                @select="handleSelect"
                @select-all="handleSelectAll"
              >
                <el-table-column type="selection" width="35"></el-table-column>
                <el-table-column prop="userName" :label="$t('notifications.userName')" width="180"> </el-table-column>
                <el-table-column prop="userId" :label="$t('notifications.userCode')" width="180">
                  <template slot-scope="scope">
                    <div v-if="!scope.row.isParent">{{ scope.row.userId }}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!-- 送信履歴一覧 -->
        <div v-show="dialogContentType === ContentType.TRANS_HISTORY_LIST">
          <div class="table-container">
            <el-table
              header-row-class-name="tti-master-table-header"
              highlight-current-row
              @current-change="onTranHistoryCurrentChange"
              :data="transmissionHistoryData"
              border
              :empty-text="$t('messages.common.emptyTableData')"
            >
              <el-table-column type="index" :label="$t('notifications.no')" width="50" align="center">
              </el-table-column>
              <el-table-column prop="sendDate" :label="$t('notifications.sendDate')" width="170" align="left">
              </el-table-column>
              <el-table-column prop="sendType" :label="$t('notifications.sendType')" width="100">
                <template slot-scope="scope">
                  {{ getSendTypelabel(scope.row.sendType) }}
                </template>
              </el-table-column>
              <el-table-column prop="title" :label="$t('notifications.title')" width="110"> </el-table-column>
              <el-table-column prop="sendContent" :label="$t('notifications.sendContext')" width="260">
                <template slot-scope="scope">
                  {{ getSendContextlabel(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column align="right" :label="$t('notifications.userCount')" width="100">
                <template slot-scope="scope">
                  {{ scope.row.receiverUserInfoList ? scope.row.receiverUserInfoList.length : 0 }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 予約送信一覧 -->
        <div v-show="dialogContentType === ContentType.RESE_TRANS_LIST">
          <div class="table-container">
            <el-table
              header-row-class-name="tti-master-table-header"
              highlight-current-row
              @current-change="onReseTranCurrentChange"
              :data="reservationTransmissionData"
              border
              :empty-text="$t('messages.common.emptyTableData')"
            >
              <el-table-column type="index" :label="$t('notifications.no')" width="50" align="center">
              </el-table-column>
              <el-table-column prop="sendDate" :label="$t('notifications.sendDate')" width="170" align="left">
              </el-table-column>
              <el-table-column prop="sendType" :label="$t('notifications.sendType')" width="100">
                <template slot-scope="scope">
                  {{ getSendTypelabel(scope.row.sendType) }}
                </template>
              </el-table-column>
              <el-table-column prop="title" :label="$t('notifications.title')" width="110"> </el-table-column>
              <el-table-column prop="sendContent" :label="$t('notifications.sendContext')" width="260">
                <template slot-scope="scope">
                  {{ getSendContextlabel(scope.row) }}
                </template>
              </el-table-column>
              <el-table-column align="right" :label="$t('notifications.userCount')" width="100">
                <template slot-scope="scope">
                  {{ scope.row.receiverUserInfoList ? scope.row.receiverUserInfoList.length : 0 }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </template>
      <template slot="foot">
        <div class="tti-message-send-foot" v-if="dialogContentType === ContentType.MESSAGE_SEND">
          <div class="tti-bottom-left-area">
            <!-- 取消 -->
            <el-button
              v-if="currentStep === 0 || currentStep === 1"
              class="tti-btn-default tti-btn-001"
              @click="onCancelClick"
              v-tooltip="getTooltip(tooltipType.messageCancel)"
              >{{ $t('buttons.cancel') }}</el-button
            >
          </div>
          <div class="tti-bottom-right-area">
            <!-- 送信履歴一覧 -->
            <el-button
              class="tti-btn-default tti-btn-002"
              @click="onShowTransHistoryList"
              v-tooltip="getTooltip(tooltipType.transHistory)"
            >
              {{ $t('buttons.listOfTransmissionHistory') }}
            </el-button>
            <!-- 予約送信一覧 -->
            <el-button
              class="tti-btn-default tti-btn-002"
              @click="onShowReseTransList"
              v-tooltip="getTooltip(tooltipType.reseTrans)"
            >
              {{ $t('buttons.reservationTransmissionList') }}
            </el-button>
            <!-- 前 へ -->
            <el-button
              v-if="currentStep === 1 || currentStep === 2"
              class="tti-btn-default tti-btn-005"
              @click="onPrevClick"
              v-tooltip="getTooltip(tooltipType.prev)"
            >
              {{ $t('buttons.prev') }}
            </el-button>
            <!-- 次 へ -->
            <el-button
              v-if="currentStep === 0 || currentStep === 1"
              class="tti-btn-default tti-btn-005"
              @click="onNextClick"
              v-tooltip="getTooltip(tooltipType.next)"
            >
              {{ $t('buttons.next') }}
            </el-button>
            <!-- 送信 -->
            <el-button
              v-if="currentStep === 2"
              class="tti-btn-default tti-btn-005"
              @click="onSendClick"
              v-tooltip="getTooltip(tooltipType.send)"
            >
              {{ $t('buttons.send') }}
            </el-button>
          </div>
        </div>
        <!-- 送信履歴一覧 -->
        <div class="tti-message-send-foot-other" v-if="dialogContentType === ContentType.TRANS_HISTORY_LIST">
          <div class="tti-bottom-right-area">
            <!-- 送信履歴一覧 -->
            <el-button class="tti-btn-default tti-btn-002" disabled @click="onShowTransHistoryList">
              {{ $t('buttons.listOfTransmissionHistory') }}
            </el-button>
            <!-- 予約送信一覧 -->
            <el-button
              class="tti-btn-default tti-btn-002"
              @click="onShowReseTransList"
              v-tooltip="getTooltip(tooltipType.reseTrans)"
            >
              {{ $t('buttons.reservationTransmissionList') }}
            </el-button>
            <!-- 詳細 -->
            <el-button
              class="tti-btn-default tti-btn-005"
              :disabled="!selectedTransmissionHistory"
              @click="onShowDetail"
              v-tooltip="getTooltip(tooltipType.detail)"
            >
              {{ $t('buttons.detail') }}
            </el-button>
            <!-- コピー -->
            <el-button
              class="tti-btn-default tti-btn-005"
              :disabled="!selectedTransmissionHistory"
              @click="onCopy"
              v-tooltip="getTooltip(tooltipType.copy)"
            >
              {{ $t('buttons.copy') }}
            </el-button>
            <!-- 戻る -->
            <el-button class="tti-btn-default tti-btn-005" @click="onBack" v-tooltip="getTooltip(tooltipType.back)">
              {{ $t('buttons.back') }}
            </el-button>
          </div>
        </div>
        <!-- 予約送信一覧 -->
        <div class="tti-message-send-foot-other" v-if="dialogContentType === ContentType.RESE_TRANS_LIST">
          <div class="tti-bottom-right-area">
            <!-- 送信履歴一覧 -->
            <el-button class="tti-btn-default tti-btn-002" @click="onShowTransHistoryList">
              {{ $t('buttons.listOfTransmissionHistory') }}
            </el-button>
            <!-- 予約送信一覧 -->
            <el-button
              class="tti-btn-default tti-btn-002"
              disabled
              @click="onShowReseTransList"
              v-tooltip="getTooltip(tooltipType.reseTrans)"
            >
              {{ $t('buttons.reservationTransmissionList') }}
            </el-button>
            <!-- 即時送信 -->
            <el-button
              class="tti-btn-default tti-btn-002"
              :disabled="!selectedReservationTransmission"
              @click="onSendNowClick"
              v-tooltip="getTooltip(tooltipType.messageSendNow)"
            >
              {{ $t('buttons.sendNow') }}
            </el-button>
            <!-- 更新 -->
            <el-button
              class="tti-btn-default tti-btn-005"
              :disabled="!selectedReservationTransmission"
              @click="onUpdateData"
              v-tooltip="getTooltip(tooltipType.messageUpdate)"
            >
              {{ $t('buttons.update') }}
            </el-button>
            <!-- 削除 -->
            <el-button
              class="tti-btn-default tti-btn-005"
              :disabled="!selectedReservationTransmission"
              @click="onDeleteClick"
              v-tooltip="getTooltip(tooltipType.messageDelete)"
            >
              {{ $t('buttons.delete') }}
            </el-button>
            <!-- 戻る -->
            <el-button class="tti-btn-default tti-btn-005" @click="onBack" v-tooltip="getTooltip(tooltipType.back)">
              {{ $t('buttons.back') }}
            </el-button>
          </div>
        </div>
      </template>
    </ttiDialog>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import { Form, Table } from 'element-ui'
import { isAfter, differenceInHours, format } from 'date-fns'
import { cloneDeep, find, findIndex } from 'lodash'

import TtiDialog from '@/components/TtiDialog.vue'
import { dialog, common } from '@/store/modules'
import manualConfig from '@/config/manualConfig'
import {
  General,
  UserMasterData,
  UserMasterTreeData,
  MessageSend,
  MessageSendListItem,
  MasterGetParam,
  ReceiveUser
} from '@/models'
import { getUserDataWithBusinessOffice, messageSend, getMessageSendList, messageDelete } from '@/store/apis'
import { MessageSendType, MessageSendListType } from '@/commons/constants'
import { i18n } from '@/locales'
import { RULES, validateService } from '@/service/validateService'
import { generalService, GeneralType } from '@/commons/services/generalService'
import helperService from '@/service/helperService'
import { msgBoxService } from '@/commons/services/msgBoxService'

/**
 * ダイアログ内容種類
 *
 * @readonly
 * @constant
 */
enum ContentType {
  MESSAGE_SEND = 'messageSend',
  RESE_TRANS_LIST = 'reseTransList',
  TRANS_HISTORY_LIST = 'transHistoryList'
}

@Component({
  name: 'home-message-send',
  components: {
    TtiDialog
  }
})
export default class HOME_MESSAGE_SEND extends Vue {
  /**
   * ツールチップタイプ
   */
  tooltipType = {
    // 戻る
    back: 'back',
    // 再送信
    reSend: 'reSend',
    // 送信履歴一覧
    transHistory: 'transHistory',
    // 予約送信一覧
    reseTrans: 'reseTrans',
    // 取消
    messageCancel: 'messageCancel',
    // 詳細
    detail: 'detail',
    // コピー
    copy: 'copy',
    // 前へ
    prev: 'prev',
    // 次へ
    next: 'next',
    // 送信
    send: 'send',
    // 即時送信
    messageSendNow: 'messageSendNow',
    // 更新
    messageUpdate: 'messageUpdate',
    // 削除
    messageDelete: 'messageDelete'
  }

  // ================================ ダイアログ ================================
  /**
   * メッセージ送信サブ画面の表示フラグを取得
   *
   * @returns {boolean} メッセージ送信サブ画面の表示フラグ
   */
  get isShow(): boolean {
    return dialog.isMessageSendDialogShow
  }

  /**
   * メッセージ送信サブ画面の表示フラグを設定する
   *
   * @param {boolean} value メッセージ送信サブ画面の表示フラグ
   */
  set isShow(value: boolean) {
    this.dialogContentType = ContentType.MESSAGE_SEND
    dialog.setMessageSendDialogShow(value)
  }

  /**
   * ダイアログ内容種類
   */
  dialogContentType = ContentType.MESSAGE_SEND

  /**
   * メッセージ送信サブ画面のマニュアルキーを取得
   *
   * @returns {string} メッセージ送信サブ画面のマニュアルキー
   */
  get manualKey(): string {
    return manualConfig.route.messageSend
  }

  /**
   * メッセージ送信サブ画面詳細の表示フラグ
   */
  isDetailShow = false

  /**
   * 詳細表示状態変更
   *
   * @param {boolean} value 表示状態
   * @returns {void}
   */
  onHandelDetailDisplay(value: boolean): void {
    this.isDetailShow = value
  }

  // ================================ メッセージ送信 ダイアログ ================================
  /**
   * ダイアログ内容種類
   *
   * @readonly
   * @constant
   */
  ContentType = ContentType

  /**
   * 今のステップ
   */
  currentStep = 0

  /**
   * タイトル
   *
   * @returns {string} タイトル
   */
  get dialogTitle(): string {
    let title = i18n.t('notifications.messageSend').toString()

    if (this.dialogContentType === ContentType.MESSAGE_SEND) {
      title = i18n.t('notifications.messageSend').toString()
    } else if (this.dialogContentType === ContentType.RESE_TRANS_LIST) {
      title = i18n.t('notifications.reseTransList').toString()
    } else if (this.dialogContentType === ContentType.TRANS_HISTORY_LIST) {
      title = i18n.t('notifications.transHistoryList').toString()
    }

    return title
  }

  /**
   * メッセージ送信フォームのref
   */
  @Ref() readonly messageSendFormRef!: Form

  /**
   * メッセージ送信Form
   */
  messageSendForm: MessageSend = {}

  /**
   * メッセージ送信Form
   */
  messageSendFormCache: MessageSend = {}

  /**
   * 検証ルール
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  messageSendRules = {} as any

  /**
   * メッセージ送信タイプリスト
   */
  messageSendTypeOptions: General[] = []

  /**
   * メッセージ送信状況
   */
  messageSendStatus: General[] = []

  /**
   * メッセージ送信フォームのref
   */
  @Ref('userSelectTable') readonly userSelectTable!: Table

  /**
   * ユーザ一覧
   */
  userData: UserMasterData[] = []

  /**
   * ユーザテーブルデータ
   */
  userTableData: UserMasterTreeData[] = []

  /**
   * ユーザテーブルで選択されたデータ
   */
  multipleSelection: UserMasterTreeData[] = []

  /**
   * ユーザテーブルで選択されたデータ
   */
  multipleSelectionCache: UserMasterTreeData[] = []

  /**
   * ユーザテーブルで選択されたユーザ
   *
   * @returns {UserMasterTreeData[]} 選択されたユーザ
   */
  get selectedUser(): UserMasterTreeData[] {
    return this.multipleSelection.filter(item => !item.isParent)
  }

  get isSendTimeDisabled(): boolean {
    return this.messageSendForm.sendType !== MessageSendType.TIME_SPECIFICATION
  }

  // ================================ 送信履歴一覧 ダイアログ ================================
  /**
   * 送信履歴一覧データ
   */
  transmissionHistoryData: MessageSendListItem[] = []

  /**
   * 選択された送信履歴
   */
  selectedTransmissionHistory: MessageSendListItem | null = null

  /**
   * 受信者情報
   */
  transmissionHistoryDetailData: ReceiveUser[] = []

  /**
   * メッセージ送信タイプ表示名を取得する
   *
   * @param {string} code メッセージ送信タイプ
   * @returns {string} 表示名
   */
  getSendTypelabel(code: string): string {
    const format = {
      code: 'code',
      value: 'name'
    }

    return helperService.getDefinitionName(this.messageSendTypeOptions, code, format)
  }

  /**
   * メッセージ状態表示名を取得する
   *
   * @param {string} code メッセージ状態
   * @returns {string} 表示名
   */
  getRecieveUserReadStatuslabel(code: string): string {
    const format = {
      code: 'code',
      value: 'name'
    }

    return helperService.getDefinitionName(this.messageSendStatus, code, format)
  }

  /**
   * 送信内容表示名を取得する
   *
   * @param {MessageSendListItem} row 送信履歴データ
   * @returns {string} 送信内容
   */
  getSendContextlabel(row: MessageSendListItem): string {
    return `${row.context1}${row.context2}${row.context3}${row.context4}`
  }

  /**
   * 再送信
   *
   * @param {ReceiveUser} row 受信ユーザ
   * @returns {void}
   */
  async onResendButtonClick(row: ReceiveUser): Promise<void> {
    const params = {
      ...this.selectedTransmissionHistory,
      receiveUserList: [row.receiveUserId],
      sendType: MessageSendType.IMMEDIATE,
      messageId: undefined
    } as MessageSend

    try {
      await messageSend(params)
      msgBoxService.info(i18n.t('notifications.I00060').toString())
    } catch (e) {
      return
    }
  }

  // ================================ 予約送信一覧 ダイアログ ================================

  /**
   * 予約送信一覧データ
   */
  reservationTransmissionData: MessageSendListItem[] = []

  /**
   * 選択された予約送信
   */
  selectedReservationTransmission: MessageSendListItem | null = null

  /**
   * インスタンスがマウントされたちょうど後にフック処理
   *
   * @returns {void}
   */
  mounted(): void {
    this.$log.debug('HOME_MESSAGE_SEND > mounted')
    this.fetchMasterData()
  }

  @Watch('isShow')
  onIsShowChange(value: boolean): void {
    this.$log.debug('HOME_MESSAGE_SEND > onIsShowChange', value)
    if (value) {
      this.fetchUserData()
      this.initForm()
      this.initRule()
      this.initValidate(this.messageSendRules, this.messageSendFormRef)
      this.currentStep = 0
    }
  }

  /**
   * マスタデータ取得
   *
   * @returns {void}
   */
  initForm(): void {
    this.messageSendForm = {
      sendType: '0',
      sendDate: new Date(),
      title: '',
      context1: '',
      context2: '',
      context3: '',
      context4: ''
    }

    this.multipleSelection = []
    this.multipleSelectionCache = []
    this.messageSendFormCache = { ...this.messageSendForm }
    if (this.userSelectTable) {
      this.userSelectTable.clearSelection()
    }
    this.currentStep = 0
  }

  /**
   * メッセージ送信検証ルール
   */
  // eslint-disable-next-line max-lines-per-function
  initRule(): void {
    this.messageSendRules = {
      // 通知題名
      title: [
        {
          required: true,
          message: i18n.t('vaildate.common.required', [i18n.t('notifications.title')]).toString(),
          trigger: 'blur'
        },
        {
          validRule: [
            // 29文字
            {
              rule: RULES.MAXLENGTH,
              number: 29,
              message: i18n.t('vaildate.common.maxlength', [i18n.t('notifications.title'), 29]).toString()
            }
          ],
          trigger: 'blur'
        }
      ],
      // 本文1
      context1: [
        {
          validRule: [
            // 29文字
            {
              rule: RULES.MAXLENGTH,
              number: 29,
              message: i18n.t('vaildate.common.maxlength', [i18n.t('notifications.context1'), 29]).toString()
            }
          ],
          trigger: 'blur'
        }
      ],
      // 本文2
      context2: [
        {
          validRule: [
            // 29文字
            {
              rule: RULES.MAXLENGTH,
              number: 29,
              message: i18n.t('vaildate.common.maxlength', [i18n.t('notifications.context2'), 29]).toString()
            }
          ],
          trigger: 'blur'
        }
      ],
      // 本文3
      context3: [
        {
          validRule: [
            // 29文字
            {
              rule: RULES.MAXLENGTH,
              number: 29,
              message: i18n.t('vaildate.common.maxlength', [i18n.t('notifications.context3'), 29]).toString()
            }
          ],
          trigger: 'blur'
        }
      ],
      // 本文4
      context4: [
        {
          validRule: [
            // 29文字
            {
              rule: RULES.MAXLENGTH,
              number: 29,
              message: i18n.t('vaildate.common.maxlength', [i18n.t('notifications.context4'), 29]).toString()
            }
          ],
          trigger: 'blur'
        }
      ]
    }
  }

  /**
   * 定義ルールを初期化する
   *
   * @param {any} allRules 定義ルール
   * @param {Form} form フォーム
   * @returns {void}
   */
  // eslint-disable-next-line
  initValidate(allRules: any, form: Form): void {
    if (!allRules) {
      return
    }
    Object.values(allRules).forEach(rules => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      for (const rule of rules) {
        if (!rule.validRule) {
          continue
        }

        rule.validator = validateService.getValidator(rule.validRule)
      }
    })

    if (form) {
      this.$nextTick(() => {
        form.clearValidate()
      })
    }
  }

  /**
   * 汎用定義メッセージ送信タイプとメッセージ種類を取得する
   *
   * @returns {void}
   */
  async fetchMasterData(): Promise<void> {
    try {
      // メッセージ送信タイプ
      this.messageSendTypeOptions = await generalService[GeneralType.MESSAGE_SEND_TYPE]
      // 送信状況
      this.messageSendStatus = await generalService[GeneralType.SEND_STATUS]
    } catch (e) {
      this.$log.debug('HOME_MESSAGE_SEND > fetchMasterData: e=', e)
      throw e
    }
  }

  /**
   * ユーザ一覧を取得する
   *
   * @returns {void}
   */
  async fetchUserData(): Promise<void> {
    try {
      const params = {
        businessOfficeList: common.favOfficeList
      } as MasterGetParam

      const userData = await getUserDataWithBusinessOffice(params)
      this.userData = userData.list as UserMasterData[]

      this.changeUserDataToTable()
    } catch (e) {
      this.$log.debug('HOME_MESSAGE_SEND > fetchMasterData: e=', e)
      throw e
    }
  }

  /**
   * ユーザデータをテーブルデータに変換する
   *
   * @returns {void}
   */
  changeUserDataToTable(): void {
    const businessOfficeMap: Record<string, UserMasterData[]> = {}
    this.userTableData = []
    this.userData.forEach((user: UserMasterData) => {
      if (user && user.businessOfficeId) {
        if (!businessOfficeMap[user.businessOfficeId]) {
          businessOfficeMap[user.businessOfficeId] = [user]
        } else {
          businessOfficeMap[user.businessOfficeId].push(user)
        }
      }
    })

    for (const businessOfficeId in businessOfficeMap) {
      const userList = businessOfficeMap[businessOfficeId]
      const userTableData: UserMasterTreeData = {
        isParent: true,
        businessOfficeId: businessOfficeId,
        userId: businessOfficeId + '-' + userList[0].userId,
        userName: userList[0]?.businessOfficeName,
        userList: userList || []
      }
      this.userTableData.push(userTableData)
    }
  }

  /**
   * 残り文字数を算出する
   *
   * @param {string} chars 本文
   * @returns {number} 残り文字数
   */
  getSurplusChars(chars: string | undefined): number {
    if (!chars) {
      return 29
    }

    return 29 - chars.length
  }

  /**
   * 表示状態変更
   *
   * @param {boolean} value 表示状態
   * @returns {void}
   */
  onHandelDisplay(value: boolean): void {
    this.dialogContentType = ContentType.MESSAGE_SEND
    dialog.setMessageSendDialogShow(value)

    this.clearSelectedData()
  }

  /**
   * 取消ボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onCancelClick(): void {
    this.$log.debug('HOME_MESSAGE_SEND > onCancelClick')

    if (!helperService.isObjectDataChanged(this.messageSendForm, this.messageSendFormCache)) {
      return
    }

    if (this.currentStep === 1) {
      if (!helperService.isTableDataChanged(this.multipleSelection, this.multipleSelectionCache)) {
        return
      }
    }

    msgBoxService.confirm(i18n.t('messages.masterCommon.cancelConfirm').toString(), this.doCancel)
  }

  /**
   * 取消処理
   *
   * @returns {void}
   */
  doCancel(): void {
    if (this.currentStep === 0) {
      this.messageSendForm = {
        sendType: '0',
        sendDate: new Date(),
        title: '',
        context1: '',
        context2: '',
        context3: '',
        context4: ''
      }

      this.messageSendFormCache = { ...this.messageSendForm }
    }

    if (this.currentStep === 1) {
      this.multipleSelection = []
      this.multipleSelectionCache = []
      if (this.userSelectTable) {
        this.userSelectTable.clearSelection()
      }
    }
  }

  /**
   * 前へボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onPrevClick(): void {
    this.$log.debug('HOME_MESSAGE_SEND > onPrevClick')
    this.currentStep--
  }

  /**
   * 次へボタンをクリックした時の処理
   *
   * @returns {void}
   */
  async onNextClick(): Promise<void> {
    this.$log.debug('HOME_MESSAGE_SEND > onNextClick')
    // メッセージ内容
    if (this.currentStep === 0) {
      const valid = await this.messageSendFormRef.validate()
      if (!valid) return

      // 時間指定
      if (this.messageSendForm.sendType === MessageSendType.TIME_SPECIFICATION) {
        if (isAfter(new Date(), new Date(this.messageSendForm.sendDate as Date))) {
          msgBoxService.info(i18n.t('notifications.E00085').toString())
          return
        }

        if (differenceInHours(new Date(this.messageSendForm.sendDate as Date), new Date()) > 24) {
          msgBoxService.info(i18n.t('notifications.E00085').toString())
          return
        }
      }

      // 即時送信
      if (this.messageSendForm.sendType === MessageSendType.IMMEDIATE) {
        delete this.messageSendForm.messageId
      }
    }

    if (this.currentStep === 1) {
      if (this.multipleSelection.length === 0) {
        msgBoxService.info(
          i18n.t('vaildate.common.selectRequired', [i18n.t('notifications.user').toString()]).toString()
        )
        return
      }
    }
    this.currentStep++
  }

  /**
   * 送信ボタンをクリックした時の処理
   *
   * @returns {void}
   */
  async onSendClick(): Promise<void> {
    this.$log.debug('HOME_MESSAGE_SEND > onSendClick')

    // 時間指定
    if (this.messageSendForm.sendType === MessageSendType.TIME_SPECIFICATION) {
      if (isAfter(new Date(), new Date(this.messageSendForm.sendDate as Date))) {
        msgBoxService.info(i18n.t('notifications.E00085').toString())
        return
      }

      if (differenceInHours(new Date(this.messageSendForm.sendDate as Date), new Date()) > 24) {
        msgBoxService.info(i18n.t('notifications.E00085').toString())
        return
      }
    }

    const params = {
      ...this.messageSendForm,
      receiveUserList: this.multipleSelection.filter(item => !item.isParent).map(item => item.id),
      sendDate: format(new Date(this.messageSendForm.sendDate as Date), 'yyyy/MM/dd HH:mm')
    } as MessageSend

    try {
      await messageSend(params)
      msgBoxService.info(i18n.t('notifications.I00060').toString())
    } catch (e) {
      return
    }
  }

  /**
   * 送信履歴一覧表示
   *
   * @returns {void}
   */
  async onShowTransHistoryList(): Promise<void> {
    const params = {
      status: MessageSendListType.HISTORY
    }

    try {
      const data = await getMessageSendList(params)
      this.transmissionHistoryData = data.list
      this.dialogContentType = ContentType.TRANS_HISTORY_LIST
    } catch (e) {
      this.$log.debug('HOME_MESSAGE_SEND > onShowTransHistoryList: e=', e)
    }
  }

  /**
   * 予約送信一覧表示
   *
   * @returns {void}
   */
  async onShowReseTransList(): Promise<void> {
    const params = {
      status: MessageSendListType.RESERVATION
    }

    try {
      const data = await getMessageSendList(params)
      this.reservationTransmissionData = data.list
      this.dialogContentType = ContentType.RESE_TRANS_LIST
    } catch (e) {
      this.$log.debug('HOME_MESSAGE_SEND > onShowTransHistoryList: e=', e)
    }
  }

  /**
   * ユーザ選択テーブルのチェックボックスをチェックする
   *
   * @returns {void}
   */
  handUserTableCheckBox(): void {
    const receiveUserList = this.messageSendForm.receiveUserList
    const targets: UserMasterData[] = []

    this.userTableData.forEach(item => {
      targets.push(...item.userList)
    })

    if (!receiveUserList) {
      return
    }

    receiveUserList.forEach(item => {
      const target = find(targets, { id: item })
      if (target) {
        this.userSelectTable.toggleRowSelection(target, true)
        this.multipleSelectionCache.push(target as UserMasterTreeData)
      }
    })

    this.handUserTableBusinessCheckBox()
  }

  /**
   * 営業所とユーザのチェックボックスの連動
   *
   * @returns {void}
   */
  handUserTableBusinessCheckBox(): void {
    this.userTableData.forEach(item => {
      let count = 0
      item.userList.forEach(user => {
        if (this.multipleSelection.find(userItem => userItem.userId === user.userId)) {
          count++
        }
      })

      if (count === item.userList.length) {
        this.userSelectTable.toggleRowSelection(item, true)
        this.multipleSelectionCache.push(item)
      }
    })
  }

  /**
   * テーブルのチェックしたデータを変更する
   *
   * @param {Array<UserMasterTreeData>} val チェックされたデータリスト
   * @returns {void}
   */
  handleSelectionChange(val: Array<UserMasterTreeData>): void {
    this.$log.debug('HOME_MESSAGE_SEND > handleSelectionChange', val)
    this.multipleSelection = val
  }

  // eslint-disable-next-line
  handleSelect(selection: any, row: any): void {
    this.$nextTick(() => {
      this.doAfterSelect(selection, row)
    })
  }

  // eslint-disable-next-line
  doAfterSelect(selection: any, row: any): void {
    this.$log.debug('HOME_MESSAGE_SEND > handleSelect', selection, row)
    const businessOfficeId = row.businessOfficeId
    const target = find(this.userTableData, { businessOfficeId })
    if (!target) {
      return
    }

    // ユーザ
    if (row.id) {
      // check off
      if (findIndex(selection, { id: row.id }) === -1) {
        this.$log.debug('HOME_MESSAGE_SEND > handleSelect > ユーザ > check off')
        this.userSelectTable.toggleRowSelection(target, false)
        // check on
      } else {
        this.$log.debug('HOME_MESSAGE_SEND > handleSelect > ユーザ > check on')
        let count = 0
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        selection.forEach((item: { id: any; businessOfficeId: any }) => {
          if (item.id && item.businessOfficeId === businessOfficeId) {
            count++
          }
        })

        if (count === target.userList.length) {
          this.userSelectTable.toggleRowSelection(target, true)
        }
      }
      // 営業所
    } else {
      // check off
      if (findIndex(this.multipleSelection, { businessOfficeId: row.businessOfficeId, isParent: true }) === -1) {
        this.$log.debug('HOME_MESSAGE_SEND > handleSelect > 営業所 > check off')
        target.userList.forEach(item => {
          this.userSelectTable.toggleRowSelection(item, false)
        })
        // check on
      } else {
        this.$log.debug('HOME_MESSAGE_SEND > handleSelect > 営業所 > check on')
        target.userList.forEach(item => {
          this.userSelectTable.toggleRowSelection(item, true)
        })
      }
    }
  }

  // eslint-disable-next-line
  handleSelectAll(selection: any): void {
    this.$nextTick(() => {
      this.doAfterSelectAll(selection)
    })
  }

  // eslint-disable-next-line
  doAfterSelectAll(selection: any): void {
    this.$log.debug('HOME_MESSAGE_SEND > handleSelectAll', selection)
    // check on
    if (findIndex(selection, { isParent: true }) !== -1) {
      this.$log.debug('HOME_MESSAGE_SEND > handleSelectAll > check on')
      this.userTableData.forEach(item => {
        item.userList.forEach(user => {
          this.userSelectTable.toggleRowSelection(user, true)
        })
      })
      // check off
    } else {
      this.$log.debug('HOME_MESSAGE_SEND > handleSelectAll > check off')
      this.userTableData.forEach(item => {
        item.userList.forEach(user => {
          this.userSelectTable.toggleRowSelection(user, false)
        })
      })
    }
  }

  /**
   * コピー
   */
  onCopy(): void {
    if (!this.selectedTransmissionHistory) return
    this.messageSendForm = {
      ...cloneDeep(this.selectedTransmissionHistory),
      receiveUserList: this.selectedTransmissionHistory.receiverUserInfoList?.map(
        item => item.receiveUserId
      ) as string[]
    }

    this.multipleSelection = []
    this.multipleSelectionCache = []
    this.userSelectTable.clearSelection()
    this.dialogContentType = ContentType.MESSAGE_SEND
    this.currentStep = 0
    this.handUserTableCheckBox()
  }

  /**
   * 更新
   */
  onUpdateData(): void {
    if (!this.selectedReservationTransmission) return
    this.messageSendForm = {
      ...cloneDeep(this.selectedReservationTransmission),
      receiveUserList: this.selectedReservationTransmission.receiverUserInfoList?.map(
        item => item.receiveUserId
      ) as string[]
    }

    this.multipleSelection = []
    this.multipleSelectionCache = []
    this.userSelectTable.clearSelection()
    this.dialogContentType = ContentType.MESSAGE_SEND
    this.currentStep = 0
    this.handUserTableCheckBox()
  }

  /**
   * 削除
   */
  onDeleteClick(): void {
    if (!this.selectedReservationTransmission) return

    const doDelete = async () => {
      const params = {
        messageId: this.selectedReservationTransmission?.messageId
      } as MessageSend

      try {
        await messageDelete(params)
        msgBoxService.info(i18n.t('notifications.I00080').toString())
        this.onShowReseTransList()
      } catch (e) {
        this.$log.debug('HOME_MESSAGE_SEND > onDeleteClick: e=', e)
      }
    }

    msgBoxService.confirm(i18n.t('messages.masterCommon.deleteConfirm').toString(), doDelete)
  }

  /**
   * 即時送信
   */
  async onSendNowClick(): Promise<void> {
    if (!this.selectedReservationTransmission) return
    const params = {
      ...this.selectedReservationTransmission,
      receiveUserList: this.selectedReservationTransmission.receiverUserInfoList?.map(
        item => item.receiveUserId
      ) as string[],
      sendType: MessageSendType.IMMEDIATE,
      messageId: undefined
    } as MessageSend

    try {
      await messageSend(params)
      msgBoxService.info(i18n.t('notifications.I00060').toString())
    } catch (e) {
      return
    }
  }

  /**
   * 詳細
   */
  onShowDetail(): void {
    this.isDetailShow = true
  }

  /**
   * メッセージ送信に戻る
   */
  onBack(): void {
    this.dialogContentType = ContentType.MESSAGE_SEND
  }

  /**
   * 送信履歴一覧単一選択
   *
   * @param {MessageSendListItem} val 送信履歴
   */
  onTranHistoryCurrentChange(val: MessageSendListItem): void {
    this.selectedTransmissionHistory = val
    if (this.selectedTransmissionHistory) {
      this.transmissionHistoryDetailData = this.selectedTransmissionHistory.receiverUserInfoList as ReceiveUser[]
    }
  }

  /**
   * 予約送信一覧単一選択
   *
   * @param {MessageSendListItem} val 予約送信
   */
  onReseTranCurrentChange(val: MessageSendListItem): void {
    this.selectedReservationTransmission = val
  }

  /**
   * 選択したデータをクリア
   *
   * @returns {void}
   */
  clearSelectedData(): void {
    this.selectedTransmissionHistory = null
    this.selectedReservationTransmission = null
  }

  /**
   * 画面ツールチップを取得する
   *
   * @param {string} key ツールチップキー
   * @returns {any} ツールチップ
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getTooltip(key: string): any {
    return {
      content: i18n.t(`master.tooltipCommon.${key}`),
      placement: 'bottom-start',
      delay: { show: 1000, hide: 0 }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .tti-message-send-dialog .el-dialog__body {
  padding: 0 0 10px 0 !important;
  height: 500px;
  overflow: auto;
}

::v-deep .el-steps--simple {
  background-color: white;

  .el-step__head {
    display: none;
  }
}

.tti-message-send-form {
  padding: 10px;

  ::v-deep .el-input {
    width: 550px;
  }

  .input-append {
    padding-left: 6px;
  }

  .tti-btn-default {
    margin-left: 0;
  }
}

.tti-message-send-foot {
  display: flex;
  justify-content: space-between;
}

.tti-message-send-foot-other {
  display: flex;
  justify-content: flex-end;
}

.table-container {
  padding-top: 10px;
}

::v-deep .cell {
  text-overflow: unset;
}

.selected-user-area {
  padding: 10px;

  label {
    font-weight: bold;
    margin: 0 10px;
  }

  label:nth-child(1) {
    margin-left: 0;
  }
}
</style>
